export default "__VITE_ASSET__Bs7j3rGV__"